var React = require('react');

function Lightning (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.36951 11.547L8.77653 3.23374C8.853 3.02529 9.05144 2.88672 9.27347 2.88672H13.8409C14.2061 2.88672 14.4616 3.24801 14.3399 3.59244L12.32 8.33295C12.1983 8.67738 12.4538 9.03868 12.8191 9.03868H17.1319C17.5869 9.03868 17.8298 9.57464 17.53 9.91679L9.34131 19.2635C8.97233 19.6847 8.28745 19.3194 8.43172 18.7783L9.99272 12.9244C10.0823 12.5883 9.82905 12.2586 9.48127 12.2586H5.86646C5.49849 12.2586 5.24279 11.8925 5.36951 11.547Z","stroke":"#8C8C8C","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Lightning.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = Lightning;

Lightning.default = Lightning;
